import React from 'react';
import { EmotionsMetadata as EmotionsMetadataBase } from '../../../reactions';
import { useApi } from '../../context/api-context/use-api';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { useModal } from '../modals';
import EmotionListModal from '../modals/reaction-list-modals/emotion-list-modal/emotions-list-modal';
const EmotionsMetadata = ({ reactionsState, commentId, config, isMobile, t, className, isPending, }) => {
    const showModal = useModal();
    const { resourceId } = useConfiguration();
    const { biOpenReactionList, biClickEmotionListTab } = useApi((state, actions) => ({
        biOpenReactionList: actions.biOpenReactionList,
        biClickEmotionListTab: actions.biClickEmotionListTab,
    }));
    return (React.createElement(EmotionsMetadataBase, { className: className, onClick: () => {
            biOpenReactionList({ resourceId, commentId, type: 'emotions' });
            showModal((toggle) => (React.createElement(EmotionListModal, { toggle: toggle, onTabChange: (tabName) => biClickEmotionListTab({ resourceId, tabName, commentId }), config: config, reactions: reactionsState.reactions, totalCount: reactionsState.total })));
        }, config: config, t: t, reactions: reactionsState.reactions, isMobile: isMobile, isPending: isPending }));
};
export default EmotionsMetadata;
//# sourceMappingURL=emotions-metadata.js.map